export default "__VITE_ASSET__piTt59k9__"